import { render, staticRenderFns } from "./RouterAlive.vue?vue&type=template&id=279e5a35&"
import script from "./RouterAlive.vue?vue&type=script&lang=js&"
export * from "./RouterAlive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports